import React from "react";
import styled from "styled-components";
import { useState,useEffect } from "react";
import { Page,FlexContainer,ScrollableContainer, AnimatedList } from "../../components/styled";
import { getPvpLeaderboard } from "../../service/main/api";
import { useDeck } from "../../context/DeckContext";
import ShinnyEffectImage from "../../assets/images/background/shinnybackground.png";
import Rank1Image from "../../assets/images/rank1.png";
import Rank2Image from "../../assets/images/rank2.png";
import Rank3Image from "../../assets/images/rank3.png";
import { useLoading } from "../../context/LoadingContext";
import Lottie from "lottie-react";
import CardBackLightAnimation from "../../assets/animations/card_back_light.json";

const PvpLeaderboard = () => {
    const [leaderboard,setLeaderboard] = useState([]);
    const [userRank,setUserRank] = useState(0);
    const [userScore,setUserScore] = useState(0);
    const {setIsLoading} = useLoading()
    const [imageLoad,setImageLoad] = useState(false)

    const fetchLeaderboard = async () => {
        setIsLoading(true)
        const { success,data } = await getPvpLeaderboard();
        if(!success){
            setIsLoading(false)
            alert("Error while fetching data")
        }
        if(data){
            console.log(data);
            setLeaderboard(data.leaderboard);
            setUserRank(data.userRank);
            setUserScore(data.userScore);
            setIsLoading(false)
        }
        // const { data } = await getPvpLeaderboard();
        // setLeaderboard(data);
    }
    useEffect(() => {
        fetchLeaderboard();
    },[])
    return (
            <ScrollableContainer style={{paddingBottom:"20px", paddingInline: 16}}>
                <TopContainer>
                    <TopLeaderContainer rank={leaderboard[1]?.rank}>
                        <img style={{marginBottom:"4px"}} src={Rank2Image} alt="rank"/>
                        <TopLeaderAvatarContainer borderColor="#69DBEF" rank={leaderboard[1]?.rank}>
                                {/* <Lottie  style={{position: "absolute",width:"100%",height:"100%", transform:"scale(1.8)"}} animationData={CardBackLightAnimation}/> */}
                                <img style={{zIndex:1}} src={leaderboard[1]?.user.avatar} alt="Avatar" />
                                <TopLeaderBadge style={{zIndex:1}} background="#69DBEF" rank={leaderboard[1]?.rank}>
                                {leaderboard[1]?.rank}
                                </TopLeaderBadge>
                                {/* <img style={{position:"absolute",width:"130px",bottom:"-40px",transform:"rotate(180deg)",height:"auto",borderRadius:"unset",zIndex:-1}} src={ShinnyEffectImage} alt="sshinny" /> */}
                        </TopLeaderAvatarContainer>
                        
                        <FlexContainer flexdirection="column" gap="4px">
                            <span style={{fontSize:"12px"}}>{leaderboard[1]?.user.username}</span>
                            <span style={{color:"#69DBEF"}}>Score: {leaderboard[1]?.score} </span>
                        </FlexContainer>
                    </TopLeaderContainer>
                    <TopLeaderContainer rank={leaderboard[0]?.rank}>
                    <img style={{marginBottom:"4px"}} src={Rank1Image} alt="rank"/>
                        <TopLeaderAvatarContainer rank={leaderboard[0]?.rank}>
                                {imageLoad && <Lottie  style={{position: "absolute",width:"100%",height:"100%", transform:"scale(1.8)"}} animationData={CardBackLightAnimation}/>}
                                <img onLoad={()=> setImageLoad(true)} style={{zIndex:1}} src={leaderboard[0]?.user.avatar} alt="Avatar" />
                                <TopLeaderBadge style={{zIndex:1}} rank={leaderboard[0]?.rank}>
                                {leaderboard[0]?.rank}
                                </TopLeaderBadge>
                                {/* <img style={{position:"absolute",width:"180px",top:"-25px",height:"auto",borderRadius:"unset",zIndex:-1}} src={ShinnyEffectImage} alt="sshinny" />
                                <img style={{position:"absolute",width:"180px",bottom:"-40px",transform:"rotate(180deg)",height:"auto",borderRadius:"unset",zIndex:-1}} src={ShinnyEffectImage} alt="sshinny" /> */}
                        </TopLeaderAvatarContainer>
                        <FlexContainer flexdirection="column" gap="4px">
                            <span style={{fontSize:"14px"}}>{leaderboard[0]?.user.username}</span>
                            <span style={{color:"#F9DE68"}}>SCORE: {leaderboard[0]?.score} </span>
                        </FlexContainer>
                    </TopLeaderContainer>
                    <TopLeaderContainer rank={leaderboard[2]?.rank}>
                    <img style={{marginBottom:"4px"}} src={Rank3Image} alt="rank"/>
                        <TopLeaderAvatarContainer borderColor="#FF8BDC" rank={leaderboard[2]?.rank}>
                                <img src={leaderboard[2]?.user.avatar} alt="Avatar" />
                                <TopLeaderBadge background="#FF8BDC" rank={leaderboard[2]?.rank}>
                                {leaderboard[2]?.rank}
                                </TopLeaderBadge>
                        </TopLeaderAvatarContainer>
                        <FlexContainer flexdirection="column" gap="4px">
                            <span style={{fontSize:"12px"}}>{leaderboard[2]?.user.username || "unknown"}</span>
                            <span style={{color:"#FF8BDC"}}>Score: {leaderboard[2]?.score} </span>
                        </FlexContainer>
                    </TopLeaderContainer>
                </TopContainer>
                <LeaderBoardItemContainer style={{background:"linear-gradient(90deg, #A241FC 0%, #214BA4 43.5%, #6BCBB0 100%)",padding:"0 21px"}}>
                <LeftContainer>
                    <span >Your current rank: {userRank}</span>
                </LeftContainer>
                <span style={{width:"90px"}}>Score: {userScore} </span>
                </LeaderBoardItemContainer>
                {React.Children.toArray(
                    leaderboard.map((item, i) => (
                        <AnimatedList style={{animationDelay:`${i * .2}s`, width:"100%", marginBottom: 10}}>
                        <LeaderBoardItemContainer style={{marginBottom:0}}>
                            <LeftContainer>
                                <AvatarContainer>
                                    <img src={item.user.avatar} alt="avatar" />
                                    <RankBadge>{item.rank}</RankBadge>
                                </AvatarContainer>
                                <span>{item.user.username || "unknown"}</span>
                            </LeftContainer>
                               <span style={{width:"90px"}}>Score: {item.score}</span>
                        </LeaderBoardItemContainer>
                        </AnimatedList>
                    ))
                )}
            </ScrollableContainer>
    )
};

const TopContainer = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 20px;
    margin-top: 20px;
    justify-content: center;
    gap: 16px;
`
const TopLeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top:${({rank})=> rank !== 1 ? "10%" : "0"}; 
    width:${({rank})=> rank === 1 ? "40%" : "30%"};;
`
const TopLeaderAvatarContainer = styled.div`
    width: 100%;
    aspect-ratio:1/1;
    position:relative;
    border:2px solid;
    border-color: ${(props)=>props.borderColor || "#F9DE68"};
    border-radius:50%;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    img{
        width:100%;
        height: 100%;
        border-radius: 50%;
    }
`
const TopLeaderBadge=styled.div`
    width: ${({rank})=> rank === 1 ? "24px" : "18px"};
    aspect-ratio:1/1;
    border-radius: 50%;
    background-color:${(props)=> props.background || "#F9DE68"};
    font-size: ${({rank})=> rank === 1 ? "16px" : "12px"};
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: ${({rank})=> rank === 1 ? "-12px" : "-9px"};
`
const LeaderBoardItemContainer = styled.div`
    display: flex;
   width: 100%;
   height:71px;
   border-radius: 21px;
   background-color:#FFFFFF29;
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    margin-bottom: 10px;
    display:flex;
    align-items: center;
    padding: 0 16px;
    justify-content: space-between;
    &:last-child{
        margin-bottom: 0;
    }
`
const AvatarContainer = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 50%;
    border: 2px solid #718FFF;
    position: relative;
    img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
    }
`
const LeftContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    gap: 12px;
    span{
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 500;
    }
`
const RankBadge = styled.div`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border:2px solid #482C5D;
    background-color: #718FFF;
    color: #FFFFFF;
    font-size:8px;
    position: absolute;
    bottom: -4px;
    right: -4px;
`
export default PvpLeaderboard;